export function setItem(key, val) {
  localStorage.setItem(key, JSON.stringify(val));
}

export function getItem(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function clearStorage() {
  localStorage.clear();
}

export function removeItem(key) {
  localStorage.removeItem(key);
}

export function setSession(key, val) {
  sessionStorage.setItem(key, JSON.stringify(val));
}

export function getSession(key) {
  return JSON.parse(sessionStorage.getItem(key));
}

export function clearSession() {
    sessionStorage.clear();
}

export function removeSessionItem(key) {
    sessionStorage.removeItem(key);
}
